<template>
  <div class="line-length-lg">
    <slot />
  </div>
</template>

<script>
  export default {
    name: 'AlertMessage'
  }
</script>
